import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-credit-reason',
  templateUrl: './credit-reason.component.html',
  styleUrls: ['./credit-reason.component.scss']
})
export class CreditReasonComponent implements OnInit {
  @Input() language;
  @Input() reason;
  @Input() title;
  constructor() { }

  ngOnInit() {
    if (this.title === '') {
      if (this.language === 'French') {
        this.title = 'Raison du crédit';
      } else {
        this.title = 'Credit Reason';
      }
    } else {
      if (this.language === 'French') {
        this.title = 'Créances Irrécouvrables';
      }
    }
  }

}
